"use strict";

exports.PREVIEW_CONTEXT = '_gatsby_plugin-graphql-preview';